import { useSelector } from 'react-redux';
import { getDeviceRegisterStatus } from '.';

export const useDeviceRegisterStatus = () =>
    useSelector(getDeviceRegisterStatus);
